import { spine } from '../utils/spine-threejs';
import vert from "../glsl/base.vert";
import frag from "../glsl/spine.frag";
import discofrag from "../glsl/discolight.frag";

const textureLoader = new THREE.TextureLoader()

AFRAME.registerComponent('spine', {
  schema: {
    bg: { type: 'asset' },
    texture: { type: 'asset' },
    atlas: { type: 'asset' },
    json: { type: 'asset' },
    texture2: { type: 'asset' },
    atlas2: { type: 'asset' },
    json2: { type: 'asset' },
    texture3: { type: 'asset' },
    atlas3: { type: 'asset' },
    json3: { type: 'asset' },
    texture5: { type: 'asset' },
    atlas5: { type: 'asset' },
    json5: { type: 'asset' },
    texture4: { type: 'asset' },
    atlas4: { type: 'asset' },
    json4: { type: 'asset' },
    animation: { default: '' },
    whaleTex: { type: 'asset' },
    whaleAtlas: { type: 'asset' },
    scale: { default: 1 },
    currIdx: {
      type: 'number',
      default: 0
    },
    pause: {
      type: 'boolean'
    },
    replay: {
      type: 'boolean'
    },
    fade: {
      type: 'number'
    }
  },

  init: function() {

    //console.log('inininininininininint')
    if (this.LOADED) return
    //console.log('inininininininininint')






    const mesh = this.el.getObject3D('mesh')
    this.mesh = mesh
    this.lastFrameTime = 0
    this.LOADED = false

    this.skeletonMeshs=[]
    this.enable = true
    this.PAUSE = true
    //var config = { alpha: false };
    //this.gl = document.querySelector('.a-canvas').getContext("webgl", config)
    //console.log(10203203404505, document.querySelector('.a-canvas').getContext("webgl", config))


    this.systemAssetManager = this.el.sceneEl.systems['asset-manager']
    this.assetManager = this.systemAssetManager.getAssetManager()

    console.log('before', this.assetManager)

    this.systemAssetManager.loadAsset(this.data.json, this.data.atlas, this.data.texture)
    this.systemAssetManager.loadAsset(this.data.json2, this.data.atlas2, this.data.texture2)
    this.systemAssetManager.loadAsset(this.data.json3, this.data.atlas3, this.data.texture3)
    this.systemAssetManager.loadAsset(this.data.json4, this.data.atlas4, this.data.texture4)
    this.systemAssetManager.loadAsset(this.data.json5, this.data.atlas5, this.data.texture5)

    //if (this.assetManager.isLoadingComplete())

    // this.assetManager = new spine.threejs.AssetManager('')
    // console.log(this.data.json, this.data.atlas, this.data.texture.src)
    // this.assetManager.loadText(this.data.json)
    // this.assetManager.loadTextureAtlas(this.data.atlas, this.data.texture.src)
    //
    //
    // //this.assetManager = new spine.threejs.AssetManager('')
    // this.assetManager.loadText(this.data.json2)
    // this.assetManager.loadTextureAtlas(this.data.atlas2, this.data.texture2.src)
    //
    // //this.assetManager = new spine.threejs.AssetManager('')
    // this.assetManager.loadText(this.data.json3)
    // this.assetManager.loadTextureAtlas(this.data.atlas3, this.data.texture3.src)
    //
    // this.assetManager.loadText(this.data.json4)
    // this.assetManager.loadTextureAtlas(this.data.atlas4, this.data.texture4.src)
    //
    // this.assetManager.loadText(this.data.json5)
    // this.assetManager.loadTextureAtlas(this.data.atlas5, this.data.texture5.src)

    console.log('after', this.assetManager)



    const textureWidth = this.el.components.geometry.data.width
    const textureHeight = this.el.components.geometry.data.height
    const textureRatio = textureWidth / textureHeight
    const viewportCanvas = document.querySelector('.a-canvas')
    let viewWidth, viewHeight
    viewWidth = viewportCanvas.attributes.width.value
    viewHeight = viewportCanvas.attributes.height.value



    this.material = new THREE.ShaderMaterial({
     transparent: true,

     uniforms: {
        bg: {
          type: 't',

        },
        opacity:{
          type: 'f',
          value: 0
        },
        time: {
          type: 'f',
          value: 0
        },
        ratio: {
          type: 'f',
          value: textureHeight/textureWidth
        },


     },
     vertexShader: vert,
     fragmentShader: discofrag,
    })
    this.material.depthTest = false
    this.material.opacity = 0
    mesh.material = this.material



  },

  update: function(oldData) {

    if (this.data.currIdx === 4){
      if (!this.light){
        this.light = document.createElement('div')
        this.light.style.width = window.innerWidth+'px'
        this.light.style.height = window.innerHeight+'px'
        this.light.style.position = 'fixed'
        this.light.style.zIndex = 9999
        this.light.style.background = '#00B5FF'
        this.light.style.pointerEvents = 'none'
        this.light.style.opacity = 0
        document.body.appendChild(this.light)
      }
    } else{
      this.mesh.material.uniforms.opacity.value = 0
      this.mesh.material.needsUpdate = true
      if (this.light){
        document.body.removeChild(this.light)
        this.light = null
      }
    }

    if (oldData.currIdx === undefined && this.data.currIdx < 6) return

    if (this.data.currIdx === 6) {
      this.mesh.remove(this.skeletonMesh)
      return
    }

    if (this.skeletonMeshs.length>0 && oldData.currIdx !== this.data.currIdx && this.data.currIdx<6) {


      this.mesh.remove(this.skeletonMesh)
      this.skeletonMesh = this.skeletonMeshs[this.data.currIdx-1]
      this.skeletonMesh.state.setAnimation(0, this.data.animation, false)
      this.mesh.add(this.skeletonMesh)
      this.enable = true
      this.skeletonMesh.update(16/1000)

    } else {

    }



    //this.PAUSE = this.data.pause
    //console.log(this.PAUSE)
    //console.log(9090909090, oldData.currIdx, this.data.currIdx, this.skeletonMeshs.length,  this.skeletonMesh)

    if (this.skeletonMesh.batches[0]){
      //this.material.uniforms.texture1.value = this.skeletonMesh.batches[0].material.uniforms.map.value
      //console.log(this.skeletonMesh.batches[0].material.uniforms)
      this.skeletonMesh.batches[0].material.uniforms.fade.value = this.data.fade


      this.material.needsUpdate = true
    }

  },

  loaded: function() {

  },

  tick: function(time, timeDelta) {
    if (this.LOADED){
      this.render(timeDelta)
    } else {
      this.load()
    }

    //this.mesh.material.uniforms.time.value = time







  },

  loadMesh: function(atlasId, jsonId, scale){
    // Load the texture atlas using name.atlas and name.png from the AssetManager.
    // The function passed to TextureAtlas is used to resolve relative paths.
    let atlas = this.assetManager.get(atlasId)

    // Create a AtlasAttachmentLoader that resolves region, mesh, boundingbox and path attachments
    let atlasLoader = new spine.AtlasAttachmentLoader(atlas)

    // Create a SkeletonJson instance for parsing the .json file.
    let skeletonJson = new spine.SkeletonJson(atlasLoader)

    // Set the scale to apply during parsing, parse the file, and create a new skeleton.
    skeletonJson.scale = scale
    let skeletonData = skeletonJson.readSkeletonData(this.assetManager.get(jsonId))

    // Create a SkeletonMesh from the data and attach it to the scene
    let skeletonMesh = new spine.threejs.SkeletonMesh(skeletonData)
    skeletonMesh.state.setAnimation(0, this.data.animation, false)
    //skeletonMesh.position.y = -window.innerHeight/2-50
    skeletonMesh.zOffset = 0
    skeletonMesh.depthTest = false
    return skeletonMesh
  },

  load: function (name, scale) {
    if (this.assetManager.isLoadingComplete()) {

      let vh = window.innerHeight+100
      let designRatio = 812/375
      let currRatio = window.innerHeight/window.innerWidth
      let ratio = designRatio/currRatio
      if (ratio !== 1)
        vh = window.innerHeight*ratio

      let skeletonMesh1 = this.loadMesh(this.data.atlas, this.data.json, vh/3268)
      let skeletonMesh2 = this.loadMesh(this.data.atlas2, this.data.json2, vh/3096)
      let skeletonMesh3 = this.loadMesh(this.data.atlas3, this.data.json3, vh/3668)
      let skeletonMesh4 = this.loadMesh(this.data.atlas4, this.data.json4, vh/4480)
      let skeletonMesh5 = this.loadMesh(this.data.atlas5, this.data.json5, vh/2403)
      skeletonMesh1.position.y = -vh/2
      skeletonMesh2.position.y = -vh/2
      skeletonMesh3.position.y = -vh/2
      skeletonMesh4.position.y = -vh/2
      skeletonMesh5.position.y = -vh/2



      this.skeletonMeshs.push(skeletonMesh1)
      this.skeletonMeshs.push(skeletonMesh2)
      this.skeletonMeshs.push(skeletonMesh3)
      this.skeletonMeshs.push(skeletonMesh4)
      this.skeletonMeshs.push(skeletonMesh5)


      //this.skeletonMesh.position.z = 300
      this.skeletonMesh = this.skeletonMeshs[this.data.currIdx-1]
      this.mesh.add(this.skeletonMesh)

      this.skeletonMesh.update(16/1000)

      // for (let i =0;i<this.skeletonMesh.length;i++){
      //   this.mesh.add(this.skeletonMesh[i])
      //
      // }

      this.LOADED = true

    }
  },
  replay: function() {
    //console.log('ooooooooooooooooo!!!!!!!!!!')
    //this.skeletonMesh.state.getCurrent(0).reset()
    this.skeletonMesh.state.setAnimation(0, this.data.animation, false)
    this.skeletonMesh.update(16/1000)

  },
  pause1: function(){
    //console.log('pause')
    this.PAUSE = true
  },
  play1: function(){
    //console.log('play')
    this.PAUSE = false
  },

  render: function(timeDelta) {

    if (this.PAUSE) return
    //console.log("!!!!!!!!!!!!", timeDelta/1000)

    if (this.data.currIdx === 4) {
      let timeline = this.skeletonMeshs[3].state.getCurrent(0).getAnimationTime()
      //console.log(time/1000, timeDelta, timeline)
      //this.light.style.opacity = timeline-8
      let opacity = 0
      if (timeline > 8 && timeline < 9) {
        this.light.style.opacity = (1-Math.abs((timeline-8)-0.5)/0.5)*this.data.fade
      }

      switch (true) {
        case timeline > 5 && timeline < 6:
          opacity = timeline-5
          break
        case timeline >= 6 && timeline <= 27:
          opacity = 1
          break
        case timeline > 27 && timeline < 28:
          opacity = 28-timeline
          break
      }



      opacity *= this.data.fade
      this.mesh.material.uniforms.opacity.value = opacity
      this.mesh.material.needsUpdate = true
      // if (timeline > 4 && timeline < 5){
      //   this.light.style.opacity = 1-(timeline-4)
      // }
    } else {
      this.mesh.material.uniforms.opacity.value = 0
      this.mesh.material.needsUpdate = true
    }




    this.skeletonMesh.update(timeDelta/1000)





  },
  viewportResize: function() {

  },

  remove: function() {
    this.mesh.remove(this.skeletonMesh)
    if (this.light)
      document.body.removeChild(this.light)
    //window.removeEventListener('resize', this.viewportResize)
  },
});

